(() => {
  const updateRecipeFacts = (root = document) => {
    root.querySelectorAll('.mxpet-product--catz-finefood .cff-story').forEach((story) => {
      story.querySelectorAll('.cff-hero h2, .cff-section h3').forEach((heading) => {
                heading.setAttribute('role', 'presentation');
                      });

                            const flavour = story.querySelector('.cff-hero h2 em')?.textContent.trim();
      if (!flavour) return;

      const recipeFact = Array.from(story.querySelectorAll('.cff-fact')).find((fact) => {
        return fact.querySelector('span')?.textContent.trim().toLowerCase() === 'recipe';
      });

      const value = recipeFact?.querySelector('strong');
      if (value) value.textContent = flavour;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => updateRecipeFacts(), { once: true });
  } else {
    updateRecipeFacts();
  }

  document.addEventListener('shopify:section:load', (event) => updateRecipeFacts(event.target));
})();
